import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Opinion.scss';
import ekaterina from '../../assets/images/ekaterina.png';
import ksyu from '../../assets/images/Ksyuhus.png';
import artyom from '../../assets/images/Artyom.png';
import anna from '../../assets/images/anna.png';
import anastasia from '../../assets/images/anastasia.png';
import jarek from '../../assets/images/Jarek.png';
import katarzyna from '../../assets/images/katarzyna.png';
import jach from '../../assets/images/jach.png';
// import { getComment } from '../helpers/Api';

export const Opinion = () => {
    
    const SamplePrevArrow = (props) => {
        const { onClick } = props;
        return <button className='prev-btn' onClick={onClick}>
            <svg width="30" height="70" viewBox="0 0 30 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27 1.56396L4 35.064L27 68.564" stroke="#5E9C81" strokeWidth="5" />
            </svg>

        </button>;
    };

    const SampleNextArrow = (props) => {
        const { onClick } = props;
        return <button className='next-btn' onClick={onClick}>
            <svg width="30" height="70" viewBox="0 0 30 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 68.064L26 35.064L3 2.06397" stroke="#5E9C81" strokeWidth="5" />
            </svg>

        </button>;
    };

    const settings = {
        arrows: true,
        prevArrow: <SamplePrevArrow />,
        nextArrow: <SampleNextArrow />,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 840,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            }
        ]
    };

    return (
        <div className='opinion'>
            <div className='container'>
                <div className='opinion__wrapp'>
                    <div className="opinion__title">
                        <div className="opinion__title-shadow">Отзывы</div>
                        <div className="opinion__title-text">отзывы</div>
                    </div>
                    <div className='slider'>
                        <Slider {...settings}>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    А
                                </span>
                                <span className='slider__name'>Антонина А.</span>
                                <p>Очень приятный мастер, хотя немного опоздал на два часа. Зато всю работу сделал идеально, а потом извинился и отказался от оплаты! Я очень довольна чисткой мебели и поражена таким отношением к клиентам :)</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    <img src={ekaterina} alt="Е" />
                                </span>
                                <span className='slider__name'>Екатерина Романовская</span>
                                <p>Сначала удивилась таким хорошим отзывам! После того, как почистили диван, поняла — секрет в том, что сервис действительно на высоте. Спасибо, буду рекомендовать!</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    <img src={ksyu} alt="К" />
                                </span>
                                <span className='slider__name'>Ксения</span>
                                <p>Очень рекомендую, всё очень понравилось! Уборка была очень тщательной. Я за это время отдохнула и сделала важные дела, не отвлекаясь на беспорядок в доме.</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    М
                                </span>
                                <span className='slider__name'>Марина Боровская</span>
                                <p>Нашла компанию в Инстаграм, заказала химчистку дивана. Казалось, что его уже не отмыть — так дети затерли светлый диван. Но через два часа он сиял как новенький. Рекомендую компанию! 👍</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    <img src={anna} alt="А" />
                                </span>
                                <span className='slider__name'>Анна Рихтер</span>
                                <p>Большое спасибо за уборку! Действительно высокое качество! Будем сотрудничать на постоянной основе и конечно порекомендуем друзьям!</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    Ф
                                </span>
                                <span className='slider__name'>Франсуа Денн</span>
                                <p>Пользовались услугами этой компании несколько раз, и они всегда обеспечивают лучший сервис! Сегодня они даже превзошли ожидания, было почти слишком чисто, ха-ха! Очень рекомендуем эту компанию!</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    <img src={anastasia} alt="А" />
                                </span>
                                <span className='slider__name'>Анастасия Попова</span>
                                <p>Благодарим за услуги химчистки мягкой мебели. На консультации ответили на все вопросы, без сомнений заказала услугу. Сотрудники приехали ровно в назначенное время. Работа была выполнена быстро и качественно. Заказали дополнительную сушку мебели, после окончания работ оставили мебель сохнуть. От всего сердца рекомендую эту клининговую компанию!</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    О
                                </span>
                                <span className='slider__name'>Ольга Макарова</span>
                                <p>Спасибо за отличный сервис. Было сложное пятно на матрасе. Всё получилось, пятно перестало быть заметным. Также чистили диван — стал как новый. Понравилось, что мастер использовал бахилы и ароматные чистящие средства.</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    П
                                </span>
                                <span className='slider__name'>Павел</span>
                                <p>Очень доволен услугой! Действительно рекомендую!</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    Т
                                </span>
                                <span className='slider__name'>Татьяна Писаренко</span>
                                <p>Чистка обивки на высшем уровне — профессиональный подход, скорость и качество! Легко связаться и записаться на визит через менеджера. Рекомендую от всего сердца.</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    <img src={katarzyna} alt="К" />
                                </span>
                                <span className='slider__name'>Катаржина Грунтковская</span>
                                <p>Очень приятная, улыбчивая команда. Уборка очень тщательная, обязательно закажем ещё раз :)</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    <img src={artyom} alt="А" />
                                </span>
                                <span className='slider__name'>Артём Воробьёв</span>
                                <p>Заказывал чистку дивана и диванных подушек. Заказ делал через Инстаграм. Общение было быстрым и приятным. Сегодня написал — завтра специалист приехал ровно в оговоренное время. Чистка была выполнена очень тщательно. Раньше из дивана летело очень много пыли, после чистки пыли нет, и диван имеет лёгкий приятный аромат :)</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    <img src={jach} alt="А" />
                                </span>
                                <span className='slider__name'>Анна Ях</span>
                                <p>Компания выполнила уборку после ремонта в частном доме, мы довольны и рекомендуем :)</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    Я
                                </span>
                                <span className='slider__name'>Янина Печинская</span>
                                <p>Пунктуально, оперативно и, что самое главное, диван отлично вычищен 👍 Обязательно рекомендую!</p>
                            </div>
                            <div className='slider__item'>
                                <span className='slider__img'>
                                    <img src={jarek} alt="Я" />
                                </span>
                                <span className='slider__name'>Ярослав Кукула</span>
                                <p>Очень хорошее сотрудничество и качество услуг, доступные цены. Счёт за услуги — за это отдельный плюс. Я очень доволен.</p>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    )
}